import { NgModule } from '@angular/core';
import { AnalyticService } from './analytic.service';

/**
 * Analytic Module.
 *
 * @exports
 * @class AnalyticModule
 */
@NgModule({
  imports: [],
  providers: [AnalyticService]
})
export class AnalyticModule {}
